// src/utils/mapLayers.js
import ImageLayer from 'ol/layer/Image'
import ImageWMS from 'ol/source/ImageWMS'
import CONFIG from '../config/GIS_Config'
/**
 * 创建WMS图层
 * @returns {ImageLayer} WMTS瓦片图层实例
 */
export function createLayerTp_node() {
  // 创建 WMS 图层
  const layerConfig = CONFIG.LAYER_PARAMS.SPECIFIC.TP_NODE
  const baseParams = CONFIG.LAYER_PARAMS.WMS_BASE
  // 创建 WMS 图层
  const imageLayer = new ImageLayer({
    source: new ImageWMS({
      url: CONFIG.SERVICE_PATHS.WMS(CONFIG.WORKSPACE),
      params: {
        LAYERS: layerConfig.LAYERS,
        STYLES: layerConfig.Style,
        FORMAT: 'image/png',
        TRANSPARENT: true,
        // version: '1.1.1',
        VIEWPARAMS: '',
      },
      serverType: baseParams.serverType,
      ratio: 1,
      projection: baseParams.projection,
    }),
    properties: {
      name: layerConfig.LAYERS.split(':')[1],
    },
  })
  return imageLayer
}
